import { inviewport, late } from "../utils/common";
import lego from "../lego";
import Logger from "../utils/log";
var isServer = typeof window === 'undefined';

// 目标对象
var hasExposure = []; // 已曝光的adTickets
var targetArr = [];
var params = {};
var height = isServer ? 0 : window.innerHeight;
var width = isServer ? 0 : window.innerWidth;
var observer = null;

// 发送埋点
var sendLegoLog = function sendLegoLog(adTickets) {
  // 已经曝光的不再上报
  if (hasExposure.indexOf(adTickets) !== -1) {
    return;
  }
  hasExposure.push(adTickets);
  var cacheParams = JSON.parse(JSON.stringify(params));
  if (!cacheParams.pagetype) cacheParams.pagetype = 'ADMARKETING';
  if (!cacheParams.actiontype) cacheParams.actiontype = 'ADTICKETSEARCH';
  cacheParams.backup = Object.assign({}, cacheParams.backup || {}, {
    adTickets: adTickets
  });
  lego.send(cacheParams, cacheParams.callback);
};

// IntersectionObserver属性的处理
var ISObserver = function ISObserver() {
  observer = new IntersectionObserver(function (entries) {
    var maxMetric = '';
    entries.forEach(function (entry) {
      if (entry.intersectionRatio && entry.intersectionRatio > 0) {
        maxMetric = entry.target.getAttribute('data-ad-ticket');
        // send lego
        if (maxMetric) sendLegoLog(maxMetric);
      }
    });
  }, {
    threshold: 0.5
  });
  targetArr.forEach(function (item) {
    observer.observe(item);
  });
};

// inviewport判断取可视区的最大值
var ExposureCollector = function ExposureCollector() {
  var maxMetric = '';
  for (var i = 0; i < targetArr.length; i++) {
    if (inviewport(targetArr[i], height, width)) {
      maxMetric = targetArr[i].getAttribute('data-ad-ticket');

      // send lego
      if (maxMetric) sendLegoLog(maxMetric);
    }
  }
};
// 滚动debounce
var act = late(ExposureCollector);

// 滚动
var exposureDefault = function () {
  var initFlag = false;
  return function () {
    // 判断上下滚动
    var startScrollTop = 0;
    if (initFlag) return;
    initFlag = true;
    window.addEventListener('scroll', function (e) {
      e.stopPropagation();
      var nextScrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
      // 下滚动才发埋点
      if (nextScrollTop - startScrollTop > 0) {
        try {
          act({});
        } catch (err) {
          // console.error(err)
        }
      }
      startScrollTop = nextScrollTop;
    }, false);
  };
}();

// 发送曝光埋点

var legoAdExposure = function legoAdExposure(legoParams, callback) {
  try {
    params = legoParams || {};
    params.callback = callback;
    if (!isServer) {
      targetArr = document.querySelectorAll('[data-ad-ticket]');
      Logger.info("lego\u5E7F\u544A\u66DD\u5149\u57CB\u70B9lego-ad-exposure");
      height = window.innerHeight;
      width = window.innerWidth;
      // 判断浏览器是否支持IntersectionObserver属性
      if (window.IntersectionObserver) {
        if (observer) observer.disconnect();
        ISObserver();
      } else {
        act({});
        // scroll滑动取值
        exposureDefault();
      }
    }
  } catch (err) {
    Logger.error("lego\u521D\u59CB\u5316\u5E7F\u544A\u66DD\u5149\u57CB\u70B9lego-ad-exposure\u62A5\u9519".concat(err));
  }
};
export default legoAdExposure;